<span
    #overlayOrigin
    tiptapDraggable
    (click)="onVariableClick($event)"
    [ngClass]="{ editable: isEditable(), selected: isEditable() && selected() }"
    >{{ variableText() }}</span
>
@if(isEditable() && hasOptions()){
<button class="options-button" (click)="onOptionsClick($event)">
    <mat-icon>more_vert</mat-icon>
</button>
}

<ng-template
    cdk-connected-overlay
    cdkConnectedOverlayLockPosition
    cdkConnectedOverlayHasBackdrop
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    [cdkConnectedOverlayOrigin]="overlayOrigin"
    [cdkConnectedOverlayOpen]="isVariableListPanelOpen()"
    [cdkConnectedOverlayPositions]="positions"
    [cdkConnectedOverlayWidth]="overlayWidth"
    (backdropClick)="onClosePanel()"
    (attach)="onAttached()"
    (detach)="onClosePanel()"
>
    <div role="listbox" tabindex="-1" class="mat-mdc-select-panel mdc-menu-surface mdc-menu-surface--open">
        <mat-selection-list>
            <div mat-subheader>User Variables</div>
            <mat-list-item (click)="updateVariable('userFirstName'); onClosePanel()">
                <mat-icon matListItemIcon>person</mat-icon>
                <div matListItemTitle>First Name</div>
                <div matListItemLine>eg. John</div>
            </mat-list-item>
            <mat-list-item (click)="updateVariable('userLastName'); onClosePanel()">
                <mat-icon matListItemIcon>person</mat-icon>
                <div matListItemTitle>Last Name</div>
                <div matListItemLine>eg. Doe</div>
            </mat-list-item>
            <mat-list-item (click)="updateVariable('userEmail'); onClosePanel()">
                <mat-icon matListItemIcon>person</mat-icon>
                <div matListItemTitle>Email</div>
                <div matListItemLine>eg. john.doe&#64;outlook.com</div>
            </mat-list-item>
            <mat-list-item (click)="updateVariable('emailReceipt'); onClosePanel()">
                <mat-icon matListItemIcon>receipt</mat-icon>
                <div matListItemTitle>Receipt</div>
                <div matListItemLine>Only for payable events</div>
            </mat-list-item>
            <mat-list-item (click)="updateVariable('emailFormAnswers'); onClosePanel()">
                <mat-icon matListItemIcon>receipt</mat-icon>
                <div matListItemTitle>Form Answers</div>
                <div matListItemLine>List of submitted form answers</div>
            </mat-list-item>
            <mat-divider></mat-divider>
            <div mat-subheader>Link Variables</div>
            <!-- <mat-list-item (click)="updateVariable('linkUrl'); onClosePanel()">
                <mat-icon matListItemIcon>link</mat-icon>
                <div matListItemTitle>Url</div>
                <div matListItemLine>eg. https://shareablelink.online/e/FamJamSummer</div></mat-list-item
            > -->
            <mat-list-item (click)="updateVariable('linkStartDate'); onClosePanel()">
                <mat-icon matListItemIcon>link</mat-icon>
                <div matListItemTitle>Start Date</div>
                <div matListItemLine>The start date of the platform link</div>
            </mat-list-item>
            <mat-divider></mat-divider>
            <div mat-subheader>Zoom Variables</div>
            <!-- <mat-list-item (click)="updateVariable('zoomTopic'); onClosePanel()">
                <mat-icon svgIcon="zoom_logo" matListItemIcon></mat-icon>
                <div matListItemTitle>Topic</div>
                <div matListItemLine>eg. Diamondship Webinar</div>
            </mat-list-item> -->
            <mat-list-item (click)="updateVariable('zoomJoinUrl'); onClosePanel()">
                <mat-icon svgIcon="zoom_logo" matListItemIcon></mat-icon>
                <div matListItemTitle>Join Url (Single Event)</div>
            </mat-list-item>
            <mat-list-item (click)="updateVariable('emailRegistrants'); onClosePanel()">
                <mat-icon svgIcon="zoom_logo" matListItemIcon></mat-icon>
                <div matListItemTitle>Join Url (All Events)</div>
            </mat-list-item>
        </mat-selection-list>
    </div>
</ng-template>

<ng-template
    cdk-connected-overlay
    cdkConnectedOverlayLockPosition
    cdkConnectedOverlayHasBackdrop
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
    [cdkConnectedOverlayOrigin]="overlayOrigin"
    [cdkConnectedOverlayOpen]="isOptionsPanelOpen()"
    [cdkConnectedOverlayPositions]="positions"
    (backdropClick)="onClosePanel()"
    (attach)="onAttached()"
    (detach)="onClosePanel()"
>
    <div role="listbox" tabindex="-1" class="options-panel">
        <mat-button-toggle-group [(ngModel)]="formatAs" (change)="onFormatChange($event)">
            <mat-button-toggle value="date">Date</mat-button-toggle>
            <mat-button-toggle value="datetime">Date & Time</mat-button-toggle>
        </mat-button-toggle-group>
    </div>
</ng-template>
